import { Button, Input } from '@getinapp/appetizer';
import { Col, Row } from 'react-grid-system';
import { GENDER_OPTIONS } from 'utils/constants';
import { useRegisterHook } from './hooks';
import * as S from './styles';

export const Register = () => {
  const {
    session,
    isLoading,
    isRegisterOpen,
    showInputEmail,
    handleClickButtonBack,
    handleCloseRegisterModal,
    handleSubmit,
    formikProps,
    t,
  } = useRegisterHook();

  return (
    <S.Modal
      width="15%"
      title={<S.Title>{t('@Register.create-account')}</S.Title>}
      isOpen={isRegisterOpen}
      onRequestClose={() => handleCloseRegisterModal()}
    >
      <S.Paragraph>{t('@Register.complete-your-register')}</S.Paragraph>
      <S.Small>* {t('@Register.field-required')}</S.Small>

      <form onSubmit={handleSubmit}>
        {!showInputEmail && (
          <Row direction="row" gutterWidth={15}>
            <Col>
              <Input
                label={t('@Register.phone')}
                name="phone"
                value={83991849734}
                disabled
              />
            </Col>
          </Row>
        )}
        <Row direction="row" gutterWidth={15}>
          <Col>
            <Input
              label={t('@Register.full-name')}
              name="name"
              required
              {...formikProps('name')}
            />
          </Col>
        </Row>
        <Row direction="row" gutterWidth={15}>
          <Col>
            <Input
              label={t('@Register.social-name')}
              name="social_name"
              {...formikProps('social_name')}
            />
          </Col>
        </Row>
        <Row direction="row" gutterWidth={15}>
          <Col>
            <Input
              label={t('@Register.email')}
              type="email"
              name="email"
              {...(showInputEmail
                ? {
                    disabled: true,
                    value: session?.email,
                  }
                : formikProps('email'))}
            />
          </Col>
        </Row>
        <Row direction="row" gutterWidth={15}>
          <Col>
            <Input
              label={t('@Register.birthdate')}
              name="birthday"
              inputMode="tel"
              mask={[
                {
                  mask: '00/00/0000',
                },
              ]}
              {...formikProps('birthday')}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <S.SelectWrapper>
              <label>Gênero</label>
              <select {...formikProps('gender')}>
                <option value="" disabled selected hidden>
                  Selecionar
                </option>
                {GENDER_OPTIONS.map((gender) => (
                  <option key={gender.value} value={gender.value}>
                    {gender.label}
                  </option>
                ))}
              </select>
            </S.SelectWrapper>
          </Col>
        </Row>

        <Row direction="row" gutterWidth={15}>
          <Col>
            <S.Checkbox>
              <label>
                <span>*</span> {t('@Register.i-agree')}{' '}
                <a
                  href={t('@PrivacyAndTerms.terms-of-use-link')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('@Register.terms-of-use')}
                </a>{' '}
                {t('@Register.i-know')}{' '}
                <a
                  href={t('@PrivacyAndTerms.privacy-policy-link')}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('@Register.privacy-policy')}
                </a>{' '}
                {t('@Register.of-get-in')}
              </label>
            </S.Checkbox>
          </Col>
        </Row>

        <br />
        {/* @ts-ignore */}
        <Button isFullWidth loading={isLoading} type="submit">
          {t('@Register.create-account')}
        </Button>
      </form>

      <S.BackButton onClick={handleClickButtonBack}>
        <span>{'<-'}</span>
        {t('@ConfirmEmail.back')}
      </S.BackButton>
    </S.Modal>
  );
};
